export default "__VITE_ASSET__CXcnePzx__"